import { createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme) =>
  createStyles({
    title: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: theme.spacing(2),
      flexDirection: 'row',
    },
    icon: {
      marginRight: theme.spacing(1),
      cursor: 'pointer',
    },
    assetInfoCard: {
      marginBottom: theme.spacing(2),
    },
    minimumCashBalance: {
      paddingLeft: theme.spacing(4),
      paddingBottom: theme.spacing(1),
      fontSize: '.8em',
    },
    interestRate: {
      paddingLeft: theme.spacing(4),
      paddingBottom: theme.spacing(2),
      fontSize: '.8em',
    },
  })
);
